import React from 'react';
import { useIntl } from 'react-intl';
import { LabelOutlined as CategoryIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

import PostTags from '../Shared/PostTags';
import CustomIcon from '../../DesignSystem/CustomIcon';
import { Icons } from '../../../Themes';
import { formatLabel } from '../../../Utils/Post/budget';
import { Groups } from '../../../Utils/Types';

function PostTagsBuilder({ post, space }: any) {
  const intl = useIntl();
  const items = [];
  const [lat, lng] = (post.latlng || '').split(',');

  if (post.budget) {
    items.push({
      label: formatLabel(intl, post.budget, space.currency.key),
      icon: <CustomIcon src={Icons.misc.cash} color="action" />,
    });
  }

  const tagNames = post?.included?.tags?.map((tag: any) => tag.label);
  const tagsCount = tagNames?.length || 0;
  if (tagsCount > 0) {
    if (tagsCount > 3) {
      items.push({
        label: `${tagNames.slice(0, 3).join(', ')} ${intl.formatMessage(
          { id: 'POSTS.DETAILS.MORE_TAGS' },
          { count: tagsCount - 3 },
        )}`,
        icon: <CategoryIcon />,
        tooltip: tagNames.slice(3).join(', '),
      });
    } else {
      items.push({
        label: tagNames.join(', '),
        icon: <CategoryIcon />,
      });
    }
  }

  if (!Groups.ADMINS.includes(post?.included?.owner?.role) && post?.authored_by_first_name) {
    items.push({
      label: intl.formatMessage(
        { id: 'POSTS.DETAILS.AUTHORED_BY' },
        { name: post.authored_by_first_name },
      ),
      icon: <CustomIcon src={Icons.misc.group} />,
    });
  }

  if (post.location) {
    items.push({ label: post.location, lat, lng });
  }

  if (post.event_url) {
    items.push({
      label: intl.formatMessage({ id: 'POSTS.DETAILS.EVENT.EVENT_URL' }),
      url: post.event_url,
      icon: <CustomIcon src={Icons.misc.accessPoint} color="action" />,
    });
  }

  return (
    <>
      {post.start_at && <PostTags items={[{ start_at: post.start_at, end_at: post.end_at }]} />}

      <PostTags items={items} />
    </>
  );
}

PostTagsBuilder.propTypes = {
  space: PropTypes.object.isRequired,
  post: PropTypes.shape({
    end_at: PropTypes.string,
    event_url: PropTypes.string,
    latlng: PropTypes.string,
    location: PropTypes.string,
    start_at: PropTypes.string,
  }),
};

export default PostTagsBuilder;
